var map = {
	"./default-balefire.svg": "ff05",
	"./default-basketball.svg": "0684",
	"./default-bee.svg": "70f7",
	"./default-binoculars.svg": "d548",
	"./default-blue-picture.svg": "11a1",
	"./default-branch.svg": "da39",
	"./default-buffalo.svg": "dade",
	"./default-camp.svg": "f203",
	"./default-cheese.svg": "d384d",
	"./default-chess-horse.svg": "4087",
	"./default-chess-queen.svg": "aa64",
	"./default-circle.svg": "6469",
	"./default-clover.svg": "28824",
	"./default-coconut.svg": "fa41",
	"./default-code.svg": "47fae",
	"./default-double-circle.svg": "0a6b",
	"./default-dragon.svg": "0d99",
	"./default-duck.svg": "ba8f",
	"./default-fire.svg": "14e0",
	"./default-flag-code.svg": "3b21",
	"./default-flask.svg": "de2a",
	"./default-gamepad.svg": "0f1e",
	"./default-grass.svg": "f853",
	"./default-grasshopper.svg": "b278",
	"./default-helicopter.svg": "013b9",
	"./default-helmet.svg": "1067",
	"./default-ice-cream.svg": "8f6d",
	"./default-infinity.svg": "4342",
	"./default-juice.svg": "24d9",
	"./default-label.svg": "e269",
	"./default-lightbulb.svg": "d0c3",
	"./default-lighthouse.svg": "8a49",
	"./default-lightning.svg": "4fbf",
	"./default-magic-hat.svg": "7727",
	"./default-magic-stick.svg": "19f7",
	"./default-meteor.svg": "7912",
	"./default-moon.svg": "c6b48",
	"./default-mountains.svg": "d5cd",
	"./default-orange-juice.svg": "ff5e",
	"./default-parrot.svg": "b275",
	"./default-phoenix.svg": "2512",
	"./default-picture-dark.svg": "ef77",
	"./default-picture.svg": "2b2f",
	"./default-raspberries.svg": "3c6e",
	"./default-robot.svg": "4e44",
	"./default-sailboat.svg": "8001",
	"./default-saturn.svg": "27a2",
	"./default-sheet.svg": "4d80",
	"./default-ship.svg": "23a2",
	"./default-spades.svg": "5134",
	"./default-storm.svg": "716a",
	"./default-strawberry.svg": "a0f18",
	"./default-sushi.svg": "88bc",
	"./default-target.svg": "c116",
	"./default-taxi.svg": "6ac0",
	"./default-tomato.svg": "2918",
	"./default-tornado.svg": "b478",
	"./default-toucan.svg": "1330",
	"./default-unicorn.svg": "d4ee",
	"./default-vase.svg": "d6840",
	"./default-watermelon.svg": "9ea6",
	"./default-waves.svg": "cedb",
	"./default-wheat.svg": "b982"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6a0f";